import { version as reactVersion } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import { installDevelopmentWarningRouting } from './utils/development-warnings';

import '@atlaskit/css-reset/dist/bundle.css';

/* Workaround for https://product-fabric.atlassian.net/browse/DSP-3980 */
import './atlaskit-tokens.css';

if (process.env.NODE_ENV === 'development') {
  installDevelopmentWarningRouting({
    development: true,
    reactVersion,
    origin: window.location.origin
  });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('The sandbox root element is missing.');
}
createRoot(container).render(<App />);
